import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'rr0556',
    ecrans: ['00-2']
});
